<div class="content">
  <div>
    <h3 class="title">Strikes de Alertas</h3>
    <div class="divHeaeder">
      <div class="margTop selectUser">
        <mat-form-field appearance="outline">
          <mat-label>Seleccionar Usuario</mat-label>
          <mat-select
            [(ngModel)]="userSelected"
            (selectionChange)="getStikes()"
          >
            <mat-option value="undefined">Todos</mat-option>
            <mat-option *ngFor="let user of users" [value]="user._id">
              {{ user.data.nm ? "NM:" + user.data.nm : "" }}
              {{ user.fullname }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-12 selecDiv">
        <form [formGroup]="dateRangeForm" class="date-range-form">
          <mat-form-field appearance="outline" class="date-field">
            <mat-label>Fecha inicio</mat-label>
            <input
              matInput
              [matDatepicker]="pickerStart"
              formControlName="start"
              (dateChange)="onStartDateChange()"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="pickerStart"
            ></mat-datepicker-toggle>
            <mat-datepicker #pickerStart></mat-datepicker>
          </mat-form-field>
          <mat-form-field appearance="outline" class="date-field">
            <mat-label>Fecha fin</mat-label>
            <input
              matInput
              [matDatepicker]="pickerEnd"
              formControlName="end"
              [min]="endMinDate"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="pickerEnd"
            ></mat-datepicker-toggle>
            <mat-datepicker #pickerEnd></mat-datepicker>
          </mat-form-field>
          <button mat-raised-button color="primary" (click)="applyDateRange()">
            Buscar
          </button>
        </form>
      </div>
    </div>
  </div>

  <div class="main">
    <div class="table-content mat-elevation-z8">
      <!-- <mat-toolbar>
        <div class="search-content">
          <div class="searchbar">
            <input
              #input
              class="search_input"
              (keyup)="filter($event)"
              type="text"
              placeholder="Filtrar..."
            />
            <button class="search_icon" (click)="filter($event)">
              <i class="fas fa-search"></i>
            </button>
          </div>
        </div>
      </mat-toolbar> -->
      <div class="table-scroll">
        <!-- Mat table -->
        <table
          mat-table
          matSort
          (matSortChange)="sortData($event)"
          [dataSource]="dataSource"
        >
          <ng-container matColumnDef="spacing">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element"></td>
          </ng-container>
          <ng-container matColumnDef="gai">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Gai</th>
            <td mat-cell *matCellDef="let element">{{ element.alert.gai }}</td>
          </ng-container>
          <ng-container matColumnDef="user">
            <th mat-header-cell *matHeaderCellDef>Usuario</th>
            <td mat-cell *matCellDef="let element">
              {{ element.user.fullname }}
            </td>
          </ng-container>
          <ng-container matColumnDef="createdAt">
            <th mat-header-cell *matHeaderCellDef>Creado</th>
            <td mat-cell *matCellDef="let element">
              {{ element.alert.createdAt | date : "dd/MM/yyyy hh:mm:ss" }}
            </td>
          </ng-container>
          <ng-container matColumnDef="count">
            <th mat-header-cell *matHeaderCellDef>Strikes</th>
            <td mat-cell *matCellDef="let element">
              {{ element.count }}
            </td>
          </ng-container>
          <!-- <ng-container matColumnDef="options">
            <th mat-header-cell *matHeaderCellDef>Opciones</th>
            <td mat-cell *matCellDef="let element; let i = index">
              <div class="options">
                <mat-icon
                  *ngIf="canDelete"
                  class="delete"
                  (click)="delete(element._id)"
                  >delete</mat-icon
                >
                <mat-icon *ngIf="canEdit" class="edit" (click)="edit(element)"
                  >edit</mat-icon
                >
              </div>
            </td>
          </ng-container> -->

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
      <mat-paginator
        [pageSizeOptions]="[10, 25, 100]"
        aria-label="Select page of roles"
      ></mat-paginator>
    </div>
  </div>
  <div class="btn-content"></div>
</div>
